<template>
  <div><h1>Register View</h1></div>
</template>

<script>
export default {
  name: "RegisterView",
  created() {},
  data() {
    return {};
  },
  props: {},
  methods: {},
};
</script>

<style lang="css" scoped></style>
